"use client";

import dynamic from "next/dynamic";

// Carte WebGL = client-only (pas de rendu serveur pour MapLibre / deck.gl).
const Board = dynamic(() => import("@/components/Board"), { ssr: false });

export default function Home() {
  return (
    <main className="relative flex-1 w-full overflow-hidden">
      <Board />
    </main>
  );
}
